// extracted by mini-css-extract-plugin
export default {"author-time-sync":"FeedCardAdminWrapper_author-time-sync__GKATG","author-time-sync__created-time":"FeedCardAdminWrapper_author-time-sync__created-time__UDBGL"};